import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { isMobile } from 'react-device-detect';


// class 
import AvalibleLink from "../element/AvalibleLink";
import ImageSlider from "../element/ImageSlider";
import Dialog from "../page_h/Dialog";


import '../index.css';
import Header from "../element/Header";
import AppDetails from "../page_h/AppDetails";
import { HomeURL, BackendCall } from "../s_data/file";



//icon adnd iamges
import Design1 from '../images/test_img_1.svg';
import SplashPage from "./SplashPage";





const imageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '20px',
};



function ProjectInfo({ tempInput }) {


  const [showDetails, setShowDetails] = useState(false);

  const handleToggle = () => {
    setShowDetails(prevState => !prevState);
  };





  //param
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const inputProjectID = tempInput ? tempInput : params.get('id') ? params.get('id') : "null"


  //data
  const [loading, setLoading] = useState(true);
  const [loadingTime, setLoadtingTime] = useState(true);
  const [projectData, setProjectData] = useState(null);


  //
  useEffect(() => {
    const fetchData = async () => {

      getProjectInfo();
      const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      await delay(1000);
      setLoadtingTime(false);
    };

    fetchData();
  }, []);



  //header info
  const headerInfo = [
    { "title": "All Project", "id": "project" },
    { "title": "Contact", "id": "contact" },
  ]



  const headerCallBack = (id) => {
    switch (id) {
      case "reload":
        window.location.reload();
        break;
      case "home_page":
      case "contact":
      case "project":
        window.location.href = "/";
        break;
      default:
        break;
    }
  };



  //get apps
  function getProjectInfo() {
    setLoading(true);

    let headersList = {
      "x-api-key": "C#nS%!#l$k8MdasibVmE5U&f(a?",
      "Content-Type": "application/x-www-form-urlencoded",
    };

    let bodyContent = `package_name=${inputProjectID}`;

    var requestOptions = {
      url: `${BackendCall}/project/info`,
      method: "POST",
      headers: headersList,
      data: bodyContent,
      withCredentials: true,
    };

    axios
      .request(requestOptions)
      .then((response) => {
        const jsonObject = response.data;

        if (jsonObject.result_code === 1) {
          setProjectData(jsonObject.list);
        }
        else {
          setProjectData(null);
          window.location.href = "/";
        }

        setLoading(false);
      })
      .catch((error) => {
        console.log("error: " + error);
        setProjectData(null);
        setLoading(false);
      });
  }





  return (
    <div className="flex flex-col h-screen">
      {(loading || loadingTime || projectData === null) ? (<SplashPage />) : (

        <div className="custom-scrollbar-p bg-fj">
          <Header logoInfo={"logo"} info={headerInfo} callBack={(id) => headerCallBack(id)} />

          {/* //style */}
          {(isMobile) ? (<img src={Design1} alt="" className="fixed inset-0 w-80 h-80 z-10 scale top-[-10px] left-[-180px] transform  scale-150"></img>
          ) : (<img src={Design1} alt="" className="fixed inset-0 w-80 h-80 z-10 top-[-100px] left-[-50px] transform scale-300"></img>)}

          {/* //empty div */}
          <div className="h-9"></div>

          <div className="screen_container">



            {/* One item */}
            <div className={`flex w-full flex-col`}>


              {/* Left */}
              <div className={`flex h-full w-full py-40 flex-col items-center justify-center ${projectData.project_type === "web" ? "w-1/3" : "w-1/2"}`}>

                {/* App icon and title */}
                <img src={projectData.app_icon} className="w-32 h-32 rounded-3xl" alt="App Icon" />
                <div className="mt-7 mb-2 text-3xl font-bold">{projectData.app_name}</div>

                {/* //project by */}
                <div className="mb-7 text-lg font-bold opacity-50">
                  {
                    projectData.own === "own"
                      ? "OWN"
                      : projectData.own === "client"
                        ? "Client"
                        : ""
                  }
                </div>



                {/* Short description */}
                <div className={`${isMobile ? "w-full px-4" : "w-3/5"} my-3 text-lg text-center`}>
                  <div className="text-white" dangerouslySetInnerHTML={{ __html: projectData.short_des.replace(/\n/g, '<br />') }} />
                </div>


                {/* Download button */}
                <div className="mt-8">
                  <AvalibleLink type={projectData.avalible_on} link={projectData.p_links} name={projectData.app_name} />
                </div>


                {/* View More Details button on mobile */}
                {isMobile && (
                  <button className="px-4 text-white rounded-lg" onClick={handleToggle} >More Details</button>
                )}


              </div>





              <div className="mb-7 text-lg font-bold opacity-50 px-10">Screenshot</div>

              {/* Right for web */}
              {Array.isArray(projectData.appScreenshots) && projectData.appScreenshots.length > 0 && (
                <div className={`flex flex-col items-center justify-center ${isMobile ? "py-6" : "w-full"}`}>

                  <div className={`grid gap-4 px-4
      ${projectData.project_type === "web" ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3" : "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4"}
    `}>
                    {projectData.appScreenshots.map((url, index) => (
                      <img
                        key={index}
                        src={url.link}
                        alt={`screenshot-${index}`}
                        className="w-full h-auto object-contain rounded-lg"
                      />
                    ))}
                  </div>

                </div>
              )}



              {/* Trigger Dialog for mobile */}
              {showDetails && <Dialog projectData={projectData} onClose={handleToggle} />}

            </div>

            <div className="h-10"></div>
            <div className="h-10"></div>

            {/* Description */}
            <div className={`${isMobile ? "w-full px-4" : "w-3/5"} my-3 text-lg  mx-auto`}>
              <div className="text-white" dangerouslySetInnerHTML={{ __html: projectData.long_des.replace(/\n/g, '<br />') }} />
            </div>


            <div className="h-10"></div>
            <div className="h-10"></div>

          </div>

        </div>
      )}
    </div>
  )
}


export default ProjectInfo;